import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostCompleteCompanyOnboardingFlowParams,
  TPostCompleteCompanyOnboardingFlowResponse,
} from "./postCompleteCompanyOnboardingFlow.schema";

export const postCompleteCompanyOnboardingFlow = (axios: IAxiosInstance) => {
  return async (params: TPostCompleteCompanyOnboardingFlowParams) => {
    const { companyID } = params;
    const response = await axios.noRetry.post<
      IApiResponse<TPostCompleteCompanyOnboardingFlowResponse>
    >(`/api/companies/${companyID}/complete-onboarding-flow`);
    const resData = response.data;
    if (resData?.success) {
      return {
        success: true,
        message: resData.data,
      };
    }
    throw new Error("Something went wrong");
  };
};
